import React from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import Typography from '@mui/material/Typography'
import AccountButton from 'components/atoms/AccountButton'

// helpers
import { centsToDollars } from 'lib/helpers/money'

const CartGuestPass = ({ product, redeemablePass, onClickRemove }) => {
  const { days, displayCode } = redeemablePass

  return (
    <Box display='flex' alignItems='center'>
      <Box display='flex' flexShrink={0}>
        <Typography variant='body1' display='inline' mr={1}>
          {days} {product.description}
        </Typography>
        <Typography
          variant='body1'
          fontFamily='monospace'
          display='inline'
          mr={1}
        >
          {displayCode}
        </Typography>
        <Typography variant='body1' display='inline'>
          – {centsToDollars(product.variablePriceCents)}/day
        </Typography>
      </Box>
      <Box display='flex'>
        <AccountButton
          size='small'
          variant='text'
          color='error'
          onClick={onClickRemove}
        >
          Remove
        </AccountButton>
      </Box>
    </Box>
  )
}

export default CartGuestPass
